import { useMutation } from '@gogame/query';

import { toggleAutoSyncPartnerAudience } from 'scenes/CustomAudiences/PartnerAudiences/sources/partnerAudiences';

import { autoSyncPA } from '../queryKeyFactory';

export const useAutoSyncPA = () => {
  const syncPAMutation = useMutation(
    autoSyncPA(),
    toggleAutoSyncPartnerAudience,
    {
      successMessage: () => 'Audience synced',
    }
  );

  const handleAction = async ({ id }) => {
    await syncPAMutation.mutateAsync({ id });
  };

  return [handleAction, syncPAMutation];
};
